import * as React from 'react';
import ActionButtons, { ActionButton } from './ActionButtons';
import '../css/promotional-banner.sass';

interface PromotionBannerProps {
  description: React.ReactNode;
  buttons: ActionButton[];
  theme?: 'night' | 'day';
}

export default function PromotionalBanner(props: PromotionBannerProps) {
  const { theme = 'day' } = props;
  const { buttons } = props;
  for (let index = 0; index < buttons.length; index++) {
    const element = buttons[index];
    element.theme = theme;
  }
  return (
    <div className={`promo-banner ${theme}`}>
      <div className="description">{props.description}</div>
      <div className="promo-banner-btn">
        <ActionButtons buttons={buttons} />
      </div>
    </div>
  );
}
